// Theme tokens rather than a hard-coded purple: the licence popups must stay readable in dark Teams.
// The fallbacks are the light Teams values, for a tree rendered without the Teams theme.
const colorScheme = (theme) => theme.siteVariables?.colorScheme;
export const mutedTextStyles = ({ theme }) => ({ color: colorScheme(theme)?.default?.foreground2 ?? "#605E5C" });
export const softBrandStyles = ({ theme }) => ({
    borderRadius: "50%",
    background: colorScheme(theme)?.brand?.background1 ?? "#dcdffa",
    color: colorScheme(theme)?.brand?.foreground1 ?? "#5b5fc7",
    "& svg": { color: colorScheme(theme)?.brand?.foreground1 ?? "#5b5fc7" },
});
export const heroIconStyles = (params) => ({ ...softBrandStyles(params), width: "56px", height: "56px", marginBottom: "0.25rem" });
